import MediaGalleryOverlay from './MediaGalleryOverlay.js';
export default MediaGalleryOverlay;
//# sourceMappingURL=index.js.map